import { XEMEX_OID } from '@core/constants/company.constant';
import { UserProfile, getUserActivePartner } from '@core/models/user.model';

// The provision route looks the installer up in the partner table, which has no row for Xemex
// itself. A Xemex user therefore links a device on behalf of the partner that owns the location,
// and any other user as their own active partner.
export function installerOidFor(
  user: UserProfile | undefined,
  locationPartnerOid: string | null | undefined,
): string | undefined {
  const activePartnerOid = getUserActivePartner(user)?.partnerOid;
  return activePartnerOid === XEMEX_OID ? (locationPartnerOid ?? undefined) : activePartnerOid;
}
